import React from 'react';

import type { Logo } from 'client-ribbons-design-system/types/logo';

export const IconPaymentKlarna = ({ height = '32', width = '50' }: Logo) => (
  <svg
    data-testid="icon-payment-klarna"
    height={height}
    viewBox="0 0 50 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Klarna logo</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#FFB3C7" height="32" rx="6" width="50" />
      <g fillRule="nonzero" transform="translate(0 2)">
        <rect fill="#FFB3C7" height="27.451" rx="4.321" width="50" />
        <path
          d="M44.906 16.083c-.647 0-1.172.56-1.172 1.25 0 .691.525 1.25 1.172 1.25.648 0 1.172-.559 1.172-1.25 0-.69-.524-1.25-1.172-1.25zm-3.857-.966c0-.946-.757-1.712-1.692-1.712-.934 0-1.692.766-1.692 1.712 0 .945.757 1.712 1.692 1.712.935 0 1.692-.767 1.692-1.712zm.007-3.327h1.867v6.653h-1.867v-.425a3.134 3.134 0 0 1-1.852.61c-1.818 0-3.291-1.572-3.291-3.511 0-1.94 1.473-3.51 3.291-3.51.687 0 1.324.225 1.852.609v-.426zm-14.946.867v-.867h-1.913v6.653h1.917v-3.106c0-1.048 1.065-1.611 1.804-1.611h.022v-1.935c-.759 0-1.456.346-1.83.866zm-4.764 2.46c0-.946-.757-1.712-1.692-1.712-.935 0-1.692.766-1.692 1.712 0 .945.757 1.712 1.692 1.712.935 0 1.692-.767 1.692-1.712zm.007-3.327h1.867v6.653h-1.867v-.425a3.134 3.134 0 0 1-1.852.61c-1.818 0-3.291-1.572-3.291-3.511 0-1.94 1.473-3.51 3.291-3.51.687 0 1.324.225 1.852.609v-.426zm11.241-.179c-.746 0-1.452.247-1.924.929v-.75h-1.86v6.653h1.883v-3.496c0-1.012.636-1.507 1.402-1.507.82 0 1.292.523 1.292 1.493v3.51h1.866v-4.23c0-1.549-1.154-2.602-2.659-2.602zm-19.105 6.832h1.955V8.825h-1.955v9.618zm-8.587.003h2.07V8.824h-2.07v9.622zm7.24-9.622c0 2.083-.761 4.02-2.118 5.461l2.862 4.161h-2.557l-3.11-4.522.803-.641c1.33-1.063 2.094-2.689 2.094-4.46h2.026z"
          fill="#0A0B09"
        />
      </g>
    </g>
  </svg>
);
